import { useContext, useEffect, useState } from 'react';
import ErrorAlert from '../../atoms/ErrorAlert/ErrorAlert';
import WideButton from '../../atoms/WideButton/WideButton';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';
import Dialog from '../Dialog/Dialog';
import LabelledInput from '../../atoms/LabelledInput/LabelledInput';
import NotificationToggle from '../NotificationToggle/NotificationToggle';
import { IAccountData } from '../../../services/GiftsApi';
import './SettingsDialog.scss';

interface SettingsDialogProps {
    onClose: (dob: string) => void;
    onCancel: () => void;
}

const SettingsDialog = (props: SettingsDialogProps) => {

    const { giftsApi } = useContext(GlobalVariablesContext);

    const [user, setUser] = useState<IAccountData>(null);

    const [loadAccountError, setLoadAccountError] = useState('');

    const [dob, setDob] = useState('');

    const [birthday14, setBirthday14] = useState(false);

    const [saveError, setSaveError] = useState('');

    const handleSaveButtonClick = async () => {
        setSaveError('');
        await giftsApi
            .editAccount({
                dateOfBirth: dob,
                notifications: birthday14 ? ['birthdays-14'] : []
            })
            .then(data => {
                props.onClose(dob);
            })
            .catch(error => {
                setSaveError(error.response.data.error);
            });
    }

    const loadAccount = async () => {
        setLoadAccountError('');
        setUser(null);
        await giftsApi
            .getUser()
            .then(data => {
                setUser(data.data);
                setDob(data.data.dateOfBirth);
                setBirthday14(data.data.notifications?.some(n => n === 'birthdays-14') ?? false);
            })
            .catch(error => {
                setLoadAccountError(error.response.data.error);
            });
    }

    useEffect(() => {
        loadAccount();
    }, []);

    const handleCancelButtonClick = () => {
        props.onCancel();
    }

    return (
        <Dialog className="settings-dialog" onClose={props.onCancel}>
            <h1>Preferences</h1>
            {loadAccountError && <ErrorAlert title="Cannot Load Account" message={loadAccountError} />}
            {user && (
                <>
                    <LabelledInput name="dob" label="Date of birth:" type="date" value={dob} onChange={e => setDob(e.target.value)} required={true} />
                    {saveError && <ErrorAlert title="Cannot Save Preferences" message={saveError} />}
                    <h2>Email Notifications</h2>
                    <p>GiftMouse can send you emails to remind you of various things:</p>
                    <NotificationToggle label="Remind me 14 days before each person's birthday." checked={birthday14} onChange={setBirthday14} />
                </>
            )}
            <WideButton label="Save" onClick={handleSaveButtonClick} />
            <WideButton label="Cancel" variant='red' onClick={handleCancelButtonClick} />
        </Dialog>
    );
}

export default SettingsDialog;